module.exports = __webpack_public_path__ + "img/concrete-u.a3e5828a.png";